// extracted by mini-css-extract-plugin
module.exports = {"contents":"index-module--contents--3Tbhq","start":"index-module--start--2U-a-","buttons":"index-module--buttons--13MRw"};